export * as Themes from './themes';
export * as Colors from './colors';

import MessagesDe from './resources/messages.json';
import {Messages as MasterMessages} from '../master';

export const Messages = {...MasterMessages, ...MessagesDe};
